module.exports = __webpack_public_path__ + "static/media/oauth-modal-header-toggle.629792ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/oauth-modal-header-toggle.svg
// module id = HmKA
// module chunks = 89